import { Avatar, Chip, Clickable, Stack, Typography, Wrap } from "components";
import { formatAmount } from "helpers";
import { OnlineBadge, PremiumBadge, CoachBadge } from "./badges";

const getDoctorInitial = (name: string) => name.slice(4, 5);

interface DoctorCardProps {
  name: string;
  avatar: {
    image?: string;
    size?: "32px" | "64px";
  };
  price: {
    amount: number;
    size?: number;
  };
  description?: string;
  experience?: number;
  premium?: boolean;
  coach?: boolean;
  online?: boolean;
  active?: boolean;
  link?: string;
  onClick?(): void;
  style?: React.CSSProperties;
}

const DoctorCard: React.FC<DoctorCardProps> = ({
  name,
  description,
  experience,
  avatar,
  price,
  premium,
  coach,
  online,
  active,
  link,
  onClick,
  style,
}) => {
  return (
    <Wrap
      if={Boolean(link || onClick)}
      with={(children) => {
        return (
          <Clickable active={active} link={link} onClick={onClick}>
            {children}
          </Clickable>
        );
      }}
    >
      <Stack placeItems="center" gap={2} style={style}>
        <Avatar
          src={avatar.image}
          alt={getDoctorInitial(name)}
          badge={online ? OnlineBadge : undefined}
          size={avatar.size}
        />
        <Stack
          direction="column"
          placeItems="flex-start"
          placeContent="center"
          style={{ flex: 1, overflow: "hidden" }}
        >
          <Stack direction="column" gap={0} placeItems="flex-start">
            <Typography
              weight={500}
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                fontSize: 22
              }}
            >
              {name.trim()}
              {coach && CoachBadge}
              {premium && !coach && PremiumBadge}
            </Typography>

            <Typography
              size={-1}
              color="#757575"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {description}
            </Typography>
          </Stack>
          {experience && <Chip>{experience}-year experience</Chip>}
        </Stack>
        {price && (
          <Typography
            size={price.size}
            weight={500}
            color="#e65100"
            whiteSpace="pre"
          >
            {formatAmount(price.amount, "₱", 2)}
          </Typography>
        )}
      </Stack>
    </Wrap>
  );
};

export { DoctorCard };
